<template>
  <router-view />
</template>

<script>
export default {
  name: "VerifyIdentityBase"
};
</script>
